import React, {Component} from 'react';

class TableData extends Component{
  constructor(props){
    super(props);
    this.state={props}
  }

  render(){
    return(
      <td>{this.state.props.content}</td>
    );
  }
}

class TableHeader extends Component{
  constructor(props){
    super(props);
    this.state={props}
  }

  render(){
    return(
      <th>{this.state.props.content}</th>
    );
  }
}

class TableRow extends Component{
  constructor(props){
    super(props);
  }
}

export default TableData;



// WEBPACK FOOTER //
// ./src/utils/tableUtil.js